module.exports = __webpack_public_path__ + "img/zfcg_07.487ae98b.png";